import '../../styles/pages/oops.scss';

import { Button } from '@llt-frontend/react-material-button';
import React from 'react';
import useDocumentTitle from '../hooks/utility/use-document-title';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

//

function OopsPage() {
  const { t: translate, ready: translationLoaded } = useTranslation('pages/oops');
  const location = useLocation();

  function handleClick() {
    window.history.back();
  }

  //
  // Side Effects

  useDocumentTitle(translate('oops', ''));

  //
  // Render

  if (!translationLoaded) {
    return null;
  }

  return (
    /* eslint-disable max-len */
    <div className="oops">
      <header className="oops__header">
        <h1>{translate('oops')}</h1>
        <p>{location.state?.message || translate('unexpectedIssue')}</p>
      </header>

      <p>
        <Button contained onClick={handleClick}>
          {translate('goBack')}
        </Button>
      </p>

      <p>
        {translate('stillHavingIssues')}
        <a href="mailto:techsupport@varsitytutors.com">{translate('customerSupport')}</a>.
      </p>
    </div>
    /* eslint-enable max-len */
  );
}

// Exports
// -------

export default OopsPage;
